module.exports = __webpack_public_path__ + "img/sprite11.1d4cf925.svg";